module.exports = __webpack_public_path__ + "static/squarespace_logo-283dcdb3936464327909dfcae68adbcf.png";